/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_Errortitle1Inputs */

const id_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const ms_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat`)
};

const da_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl`)
};

const de_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const en_us2_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const es_es2_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const es_mx2_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fil_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const it_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

const hu_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba`)
};

const nl_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout`)
};

const no_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil`)
};

const pl_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd`)
};

const pt_br2_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

const pt_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

const ro_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare`)
};

const fi_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe`)
};

const sv_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel`)
};

const vi_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi`)
};

const tr_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata`)
};

const cs_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba`)
};

const bg_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка`)
};

const ru_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const uk_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка`)
};

const ar_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ`)
};

const hi_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि`)
};

const th_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาด`)
};

const ja_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const zh_cn2_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const zh_hant1_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`錯誤`)
};

const ko_profile_avatar_errortitle1 = /** @type {(inputs: Profile_Avatar_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오류`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Profile_Avatar_Errortitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_errortitle1 = /** @type {((inputs?: Profile_Avatar_Errortitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_Errortitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_errortitle1(inputs)
	if (locale === "ms") return ms_profile_avatar_errortitle1(inputs)
	if (locale === "da") return da_profile_avatar_errortitle1(inputs)
	if (locale === "de") return de_profile_avatar_errortitle1(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_errortitle1(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_errortitle1(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_errortitle1(inputs)
	if (locale === "fil") return fil_profile_avatar_errortitle1(inputs)
	if (locale === "fr") return fr_profile_avatar_errortitle1(inputs)
	if (locale === "it") return it_profile_avatar_errortitle1(inputs)
	if (locale === "hu") return hu_profile_avatar_errortitle1(inputs)
	if (locale === "nl") return nl_profile_avatar_errortitle1(inputs)
	if (locale === "no") return no_profile_avatar_errortitle1(inputs)
	if (locale === "pl") return pl_profile_avatar_errortitle1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_errortitle1(inputs)
	if (locale === "pt") return pt_profile_avatar_errortitle1(inputs)
	if (locale === "ro") return ro_profile_avatar_errortitle1(inputs)
	if (locale === "fi") return fi_profile_avatar_errortitle1(inputs)
	if (locale === "sv") return sv_profile_avatar_errortitle1(inputs)
	if (locale === "vi") return vi_profile_avatar_errortitle1(inputs)
	if (locale === "tr") return tr_profile_avatar_errortitle1(inputs)
	if (locale === "cs") return cs_profile_avatar_errortitle1(inputs)
	if (locale === "bg") return bg_profile_avatar_errortitle1(inputs)
	if (locale === "ru") return ru_profile_avatar_errortitle1(inputs)
	if (locale === "uk") return uk_profile_avatar_errortitle1(inputs)
	if (locale === "ar") return ar_profile_avatar_errortitle1(inputs)
	if (locale === "hi") return hi_profile_avatar_errortitle1(inputs)
	if (locale === "th") return th_profile_avatar_errortitle1(inputs)
	if (locale === "ja") return ja_profile_avatar_errortitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_errortitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_errortitle1(inputs)
	return ko_profile_avatar_errortitle1(inputs)
});
export { profile_avatar_errortitle1 as "profile.avatar.errorTitle" }